import {getBulkActionSlice} from 'src/components/bulk-tool';

import type {
    BulkActionIdSelector,
    BulkActionShownSelector,
    BulkActionTaskSelector,
} from 'src/components/bulk-tool';

export const updateAccountTeamMemberSlice = getBulkActionSlice(
    'accountManagerUpdateResult',
);

export const selectAccountManagerUpdateShown: BulkActionShownSelector = state =>
    state.bulkUpdateResult.accountManagerUpdateResult.shown;

export const selectAccountManagerUpdateUuid: BulkActionIdSelector = state =>
    state.bulkUpdateResult.accountManagerUpdateResult.uuid;

export const selectAccountManagerUpdateTask: BulkActionTaskSelector = state =>
    state.bulkUpdateResult.accountManagerUpdateResult.backgroundTask;

export const {
    setUuid,
    setBackgroundTask,
    setShown,
    clearResult,
} = updateAccountTeamMemberSlice.actions;
